var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{staticClass:"Tabs",attrs:{"horizontal":""}},_vm._l((_vm.tabs),function(tab,index){return _c('b-list-group-item',{key:index,staticClass:"px-4",attrs:{"active":tab.id === _vm.activeTab,"button":""},on:{"click":function($event){return _vm.handleClick({ tab })}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }